import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import style from "../partnerProfileModal.module.scss";
import Loading from "../../../../shared/Loading/Loading";
import DocumentItem from "./DocumentItem";
import { File } from "../../../../../services";

const DocumentsTab = ({ partnerId, onOpenViewPhoto }) => {
  const { t } = useTranslation();

  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});

  useEffect(() => {
    if (partnerId) {
      fetchDocuments(partnerId);
    }
  }, [partnerId]);

  const fetchDocuments = (userId) => {
    if (userId) {
      setIsLoading(true);
      File.getDocList(userId)
        .then((response) => {
          setDocuments(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error(t("partnerProfile.messages.documentLoadErrorConsole"), error);
          setDocuments([]);
          setIsLoading(false);
        });
    } else {
      console.log(t("partnerProfile.messages.documentLoadImpossible"));
      setDocuments([]);
    }
  };

  const setLoadingViewer = (docId, isLoading) => {
    setLoadingStates((prev) => ({ ...prev, [docId]: isLoading }));
  };

  const handleViewDocument = (fileType, fileId) => {
    setLoadingViewer(fileType, true);
    onOpenViewPhoto(fileType, fileId, () => setLoadingViewer(fileType, false));
  };

  const filteredDocuments = documents.filter((doc) => doc?.type === 0 || doc?.type === 2);

  return (
    <div className={style.documents}>
      {isLoading ? (
        <Loading inBlock marginBottom={0} />
      ) : filteredDocuments.length > 0 ? (
        <div className={style.documentsList}>
          {filteredDocuments.map((doc, index) => (
            <DocumentItem
              key={index}
              doc={doc}
              partnerId={partnerId}
              isLoading={loadingStates[doc?.type]}
              onView={handleViewDocument}
            />
          ))}
        </div>
      ) : (
        <div className={style.noDocuments}>
          <span>{t("partnerProfile.documents.noDocuments")}</span>
        </div>
      )}
    </div>
  );
};

export default DocumentsTab;
